import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import './i18n';
import './firebase/config'; // Initialize Firebase

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import VisionMission from './pages/VisionMission';
import UAVPlatform from './pages/UAVPlatform';
import RD from './pages/RD';
import Products from './pages/Products';
import Contact from './pages/Contact';
import Admin from './pages/Admin';

// Page Transition Component
const PageTransition = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
    >
      {children}
    </motion.div>
  );
};

// App Component with Location-based Animation
const AppContent = () => {
  const location = useLocation();

  // Scroll to top on route change
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={
          <PageTransition>
            <Home />
          </PageTransition>
        } />
        <Route path="/about" element={
          <PageTransition>
            <About />
          </PageTransition>
        } />
        <Route path="/vision-mission" element={
          <PageTransition>
            <VisionMission />
          </PageTransition>
        } />
        <Route path="/uav-platform" element={
          <PageTransition>
            <UAVPlatform />
          </PageTransition>
        } />
        <Route path="/rd" element={
          <PageTransition>
            <RD />
          </PageTransition>
        } />
        <Route path="/products" element={
          <PageTransition>
            <Products />
          </PageTransition>
        } />
        <Route path="/contact" element={
          <PageTransition>
            <Contact />
          </PageTransition>
        } />
        <Route path="/admin" element={
          <PageTransition>
            <Admin />
          </PageTransition>
        } />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-white">
        <Navbar />
        <main className="flex-1">
          <AppContent />
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 